import './LicenceTabStyle.css';

import SubTabParent from "../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";

export function LicenceTab(props) {

  return (
    <SubTabParent>

      <SubTabSection>
        <p>
          Thank you for continuing to choose Shoru for your auditioning process!<br/><br/>
          This licence agreement may look very official and scary (as is the way with any legal agreement), but know 
          that we are committed to providing a reliable and consistent service as the Shoru full release is developed.<br/>
          If you encounter any issues, please feel free to reach out through the Shoru email (<b>info@shoru.app</b>), or 
          get in touch with me personally (<b>thomasjmmccarthy@gmail.com</b>). I'm always happy to help!<br/><br/>
          All the best,<br/>
          Thomas 'Tommo' McCarthy
        </p>
      </SubTabSection>

      <SubTabSection no_background>

        <h2>Closed Beta Licence Agreement (Updated: 17/02/2026)</h2>
        <p className='licence-p'>
          UK - Closed Beta Access<br/><br/>
          This Closed Beta Licence Agreement ("Agreement") governs access to and use of the beta version of 
          the CastingBot web application (the "Application" or "App") operated by Shoru ("we", "us", "our").<br/><br/>
          By accessing or using the application, you agree to the terms provided below.
        </p>

        <hr className='licence-hr'/>

        <h3>1. Beta Status</h3>
        <p className='licence-p'>
          CastingBot is provided as a <b>closed beta version</b>.<br/><br/>
          This means:<br/>
          <ul>
            <li>Features may be incomplete, unstable, or removed at any time.</li>
            <li>Data loss will occur once the full version is released.</li>
            <li>Downtime may occur without notice.</li>
            <li>The service may change significantly before public release.</li>
          </ul>
          The Application is provided for testing and evaluation purposes only.<br/>
        </p>

        <hr className='licence-hr'/>

        <h3>2. Intellectual Property</h3>
        <p className='licence-p'>
          All intellectual property rights in and to the Application, included but not limited to its:
          <ul>
            <li>Software, Source code, and Object code</li>
            <li>Design, User interface, Branding, and Databases</li>
            <li>Features and Functionality</li>
          </ul>
          and all related materials, are and shall remain exclusively the property of Thomas McCarthy / Shoru.<br/><br/>
          Nothing in this Agreement grants the user any ownership rights in CastingBot. The licence granted is limited strictly
          to the right to access and use the Application for internal purposes during the beta period.<br/><br/>
          You may not:
          <ul>
            <li>Copy, reproduce, modify, adapt, translate, or create derivative works from the Application;</li>
            <li>Reverse engineer, decompile, disassemble, or attempt to discover the source code;</li>
            <li>Remove or alter any copyright, trademark or proprietary notices;</li>
            <li>Use the Application's branding, name, or logos outside of internal purposes without prior written consent.</li>
          </ul>
          Any feedback, suggestions, improvements, or ideas provided during the beta period may be used by us 
          without restriction or compensation, and all resulting intellectual property rights shall vest solely in Thomas McCarthy / Shoru.
        </p>

        <hr className='licence-hr'/>

        <h3>3. Licence Grant</h3>
        <p className='licence-p'>
          We grant you a <b>limited, non-exclusive, non-transferable, revocable licence</b> to 
          access and use the Application for internal society purposes during the closed beta period.<br/>
          You may not:
          <ul>
            <li>Reverse engineer, decompile, or attempt to extract source code.</li>
            <li>Share access credentials outside your organisation.</li>
            <li>Resell or commercially exploit the Application.</li>
            <li>Attempt to interfere with the Application's operation or security.</li>
          </ul>
        </p>

        <hr className='licence-hr'/>

        <h3>4. Warranty and Our Commitment</h3>
        <p className='licence-p'>
          As a closed beta, the Application is provided <b>"as-is" and "as-available"</b>, without warranties of any kind.<br/>
          We do not guarantee availability or performance during the closed beta period.<br/><br/>
          Shoru is committed to providing a functional service. Support for the closed beta can be requested at any time via <a className='licence-link' href='mailto:info@shoru.app'>info@shoru.app</a>, 
          or by contacting the Lead Developer directly.
        </p>

        <hr className='licence-hr'/>

        <h3>5. Limitation of Liability</h3>
        <p className='licence-p'>
          To the maximum extent permitted by UK Law:<br/>
          We shall not be liable for:<br/>
          <ul>
            <li>Loss of data</li>
            <li>Loss of revenue</li>
            <li>Loss of opportunity</li>
            <li>Indirect or consequential loss</li>
            <li>Service interruption</li>
          </ul>
          Our total liability shall not exceed £100.<br/>
          Nothing in this Agreement limits liability for death or personal injury caused by negligence, fraud, or any liability that cannot
          be excluded under law.
        </p>

        <hr className='licence-hr'/>

        <h3>6. Data & GDPR</h3>
        <p className='licence-p'>
          You confirm that:
          <ul>
            <li>You have authority to upload any personal data submitted.</li>
            <li>You will only upload data necessary for legitimate society purposes.</li>
            <li>You will comply with UK GDPR obligations in relations to your members.</li>
          </ul>
          We will:
          <ul>
            <li>Store data securely using industry-standard hosting providers.</li>
            <li>Use data only to operate and improve the application.</li>
            <li>Not sell user data.</li>
          </ul>
          You acknowledge that beta software may not yet meet full production-grade security standards.
        </p>

        <hr className='licence-hr'/>

        <h3>7. Feedback</h3>
        <p className='licence-p'>
          Any feedback, suggestions, or bug reports you provide may be used by us without restriction or compensation.<br/><br/>
          You grant us the right to incorporate such feedback into the Application.
        </p>

        <hr className='licence-hr'/>

        <h3>8. Termination</h3>
        <p className='licence-p'>
          We may:
          <ul>
            <li>Suspend or revoke access at any time.</li>
            <li>Delete stored data upon termination.</li>
          </ul>
          We will:
          <ul>
            <li>Notify you in advance of the Beta programme ending.</li>
            <li>Not end the Beta programme during any society casting periods, to prevent crucial data loss.</li>
          </ul>
        </p>

        <hr className='licence-hr'/>

        <h3>9. Confidentiality</h3>
        <p className='licence-p'>
          You agree not to publicly share:
          <ul>
            <li>Screenshots</li>
            <li>Feature details</li>
            <li>Internal discussions</li>
            <li>Performance information</li>
          </ul>
          Without prior written permission.
        </p>

        <hr className='licence-hr'/>

        <h3>10. Governing Law</h3>
        <p className='licence-p'>
          This Agreement is governed by the laws of England and Wales.<br/><br/>
          Any disputes shall be subject to exclusive jurisdiction of the courts of England and Wales.
        </p>

      </SubTabSection>

    </SubTabParent>
  )

}